export const REQUEST_ACCESS = 'REQUEST_ACCESS';

export const CLOSE_ACCESS_PROMPT = 'CLOSE_ACCESS_PROMPT';

export const RESET_ACCESS_PROMPT = 'RESET_ACCESS_PROMPT';



// WEBPACK FOOTER //
// ./src/common/Components/AccessPrompt/state/types.js